var _circle, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTestimonialsPlaceholder = function SvgTestimonialsPlaceholder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#E9E9FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E9E9FF",
    d: "M15 14.938h20v17.624H15z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.06 32.56h-8.789c-.143 0-.288 0-.432-.015-.733-.069-1.028-.563-.715-1.23.271-.578.567-1.14.855-1.71l4.071-8.059c.042-.082.086-.164.135-.242.341-.548.897-.625 1.334-.153.308.33.57.702.845 1.06l4.194 5.485c.611.795 1.38.839 2.098.123.356-.355.704-.72 1.064-1.072.65-.636 1.387-.597 1.917.144 1.065 1.486 2.103 2.993 3.146 4.494.082.118.144.248.185.385.101.345-.042.623-.392.714-.219.053-.444.077-.67.073-2.947.005-5.895.006-8.845.003ZM31.63 17.838a2.896 2.896 0 1 1-2.873-2.9 2.91 2.91 0 0 1 2.874 2.9Z",
    fill: "#09205D"
  })));
};

export default SvgTestimonialsPlaceholder;